module.exports = __webpack_public_path__ + "img/cool_system_sicom_step2.a408f39c.jpg";